import { cx } from 'class-variance-authority';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

type CommandSeparatorProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Separator>;

const CommandSeparator = forwardRef<HTMLDivElement, CommandSeparatorProps>(({ className, ...props }, ref) => (
  <CommandPrimitive.Separator ref={ref} className={cx('h-px w-full bg-tertiary', className)} {...props} />
));
export default CommandSeparator;
